module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-BoldItalic.027e0c66.eot";